module.exports = __webpack_public_path__ + "img/17841_S.6961af56.png";